<template>
  <div>
    <div class="top">
      <h3>{{time}}</h3>
      <p>{{today}}</p>
    </div>
    <h3 class="titles">电影票详情</h3>
    <div class="content">
      <div class="title">{{detail.movie_name}}</div>
      <p>日期及场次：{{detail.film_time}}</p>
      <p class="last">放映地址：{{detail.order_ticket[0].cinema_address}}</p>
      <div class="title">座位：</div>
      <div class="seated">
        <div class="seat" v-for="(item,index) in detail.seat_arr" :key="index">{{item}}</div>
      </div>
      <div class="des">
        <p>订单编号：{{detail.order_no}}</p>
      </div>
    </div>
    <div class="ok" @click="printTicket">打印取票</div>
    <div class="back-btn" @click="goBack">返回</div>
    <div class="mask" v-if="warn!=''">
      <div class="mask-content">
        <div class="icon"></div>
        <p>{{warn}}</p>
      </div>
    </div>
    <div class="footer">
      <p>
        <!-- 设备ID：{{deviceId}} -->
        <span class="tel">
          客服电话
          <span>25650850 25650860</span>
        </span>
      </p>
    </div>
  </div>
</template>

<script>
import { setInterval, clearInterval } from "timers";
export default {
  name: "HelloWorld",
  data() {
    return {
      deviceId: localStorage.deviceNum || "123456789",
      order_id: "",
      time: "",
      today: "",
      timer: "",
      detail: "",
      ticket_list: [],
      strReturn: "",
      warn: ""
    };
  },
  mounted() {
    this.detail = JSON.parse(localStorage.movie);
    this.order_id = this.detail.order_id;
    this.get_OrderInfo();
    this.getDay();
    if (this.timer == "") {
      this.timer = setInterval(() => {
        this.getDay();
      }, 10000);
    }
  },
  destroyed() {
    clearInterval(this.timer);
  },
  methods: {
    getDay() {
      var day = new Date();
      var hours = day.getHours();
      hours = hours < 10 ? "0" + hours : hours;
      var min = day.getMinutes();
      min = min < 10 ? "0" + min : min;
      var month = day.getMonth() + 1;
      var days = day.getDate();
      var week = day.getDay();
      var strWeek = "";
      switch (week) {
        case 0:
          strWeek = "星期日";
          break;
        case 1:
          strWeek = "星期一";
          break;
        case 2:
          strWeek = "星期二";
          break;
        case 3:
          strWeek = "星期三";
          break;
        case 4:
          strWeek = "星期四";
          break;
        case 5:
          strWeek = "星期五";
          break;
        case 6:
          strWeek = "星期六";
          break;
      }
      this.time = hours + ":" + min;
      this.today = month + "月" + days + "日 " + strWeek;
    },
    // 获取订单信息
    get_OrderInfo() {
      this.$api
        .OrderInfo(localStorage.getItem("api_token"), this.order_id)
        .then(res => {
          this.order_detail = res.data;
          this.ticket_list = res.data.ticket_list;
          let ticket_list = res.data.ticket_list;
          if (res.status == 1) {
            let ticket_no = [];

            for (var i in ticket_list[0].ticket_list) {
              ticket_no.push(ticket_list[0].ticket_list[i].ticket_no);
            }
            this.ticket_no = ticket_no;
          }
          let list = res.data.ticket_list;
          let str = [];
          for (let i in list) {
            for (let j in list[i].ticket_list) {
              str.push({
                cinema_name: this.order_detail.cinema_name,
                movie_name: this.order_detail.movie_name,
                movie_date: this.order_detail.movie_date,
                start_time: this.order_detail.start_time,
                class_name: list[i].class_name,
                seat_name: list[i].ticket_list[j].seat_name,
                ticket_no: list[i].ticket_list[j].ticket_no
              });
            }
          }

          str.forEach((res, key, index) => {
            if (index == 0) {
              this.strReturn =
                res.cinema_name +
                "," +
                res.movie_name +
                "," +
                res.movie_date +
                res.start_time +
                "," +
                res.seat_name +
                "," +
                res.ticket_no +
                "," +
                this.order_detail.order_no +
                ";";
            } else {
              this.strReturn +=
                res.cinema_name +
                "," +
                res.movie_name +
                "," +
                res.movie_date +
                res.start_time +
                "," +
                res.seat_name +
                "," +
                res.ticket_no +
                "," +
                this.order_detail.order_no +
                ";";
            }
          });
        });
    },
    goBack() {
      this.$router.go(-1);
    },
    printTicket() {
      this.$api
        .PickupTicket(
          this.order_id,
          this.ticket_no,
          localStorage.getItem("api_token"),
          0
        )
        .then(ress => {
          if (ress.status == 1) {
            // 获取机器内打印纸数
            var obj = jsObj.getPageStatus();
            var num = obj.split(",")[1];

            if (Number(num) > this.ticket_list.length) {
              // 打印门票
              jsObj.PrintFilmTicket("1", this.strReturn);
              var obj = jsObj.getPageStatus();
              var num2 = Number(obj.split(",")[1]);
              var num3 = Number(obj.split(",")[2]);
              if (num2 < num3) {
                this.$router.push({
                  path: "/success",
                  query: {
                    order_id: this.order_id,
                    type: 1
                  }
                });
              } else {
                this.$router.push({
                  path: "/success",
                  query: {
                    order_id: this.order_id,
                    type: 2
                  }
                });
              }
            } else {
              this.warn = "纸张不足，请联系客服人员";
              setTimeout(() => {
                this.warn = "";
                this.$router.replace("/nopage");
              }, 1500);
            }
          } else {
            this.warn = ress.msg;
          }
        });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.container {
  width: 100%;
  min-height: 1920px;
  background: #f0f0f0;
  overflow: hidden;
  position: relative;
  padding-bottom: 165px;
  .top {
    padding: 30px 32px;
    color: #4d4d4d;
    font-size: 25px;
    h3 {
      font-size: 70px;
      margin: 0;
    }
  }
  .titles {
    font-size: 60px;
    letter-spacing: 3px;
    color: #0c5193;
    text-align: left;
    padding: 90px 60px 30px;
  }
}
.mask {
  position: fixed;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  top: 0;
  left: 0;
  z-index: 999;
  transition: all ease-in-out 300ms;
  .mask-content {
    width: 600px;
    height: 384px;
    background: #fff;
    border-radius: 6px;
    padding: 65px;
    text-align: center;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    .icon {
      width: 102px;
      height: 102px;
      background: url(.././assets/icon.png) no-repeat;
      background-size: cover;
      margin: 0 auto 80px;
    }
    p {
      color: #5c5c5c;
      font-size: 30px;
      text-align: center;
    }
  }
}
.seated {
  width: 100%;
  padding: 30px 77px 45px;
  position: relative;

  h3 {
    color: #000;
    font-size: 26px;
    margin-bottom: 15px;
  }
  p {
    color: #55555a;
    font-size: 26px;
  }
}
.ok {
  width: 670px;
  height: 98px;
  line-height: 98px;
  text-align: center;
  font-size: 30px;
  letter-spacing: 3px;
  color: #fff;
  background: rgba(185, 80, 32, 1);
  border-radius: 49px;
  margin: 50px auto;
  cursor: pointer;
}
.back-btn {
  width: 670px;
  height: 98px;
  background: rgba(0, 81, 146, 0);
  border: 2px solid rgba(185, 80, 32, 1);
  border-radius: 49px;
  line-height: 98px;
  text-align: center;
  font-size: 30px;
  letter-spacing: 3px;
  color: rgba(185, 80, 32, 1);
  margin: 0 auto;
}
.seat {
  width: 158px;
  height: 60px;
  display: inline-block;
  color: #3e70b8;
  font-size: 30px;
  text-align: center;
  line-height: 60px;
  text-align: center;
  background: url(.././assets/seat.png) no-repeat;
  background-size: 100% 100%;
  margin: 0 8px 8px 0;
}
.content {
  padding: 88px 0px 66px;
  width: 972px;
  min-height: 685px;
  margin: 0 auto 120px;
  background: rgba(255, 255, 255, 1);
  border: 1px solid rgba(0, 81, 146, 1);
  border-radius: 14px;
  position: relative;
  &:after {
    content: "";
    width: 62px;
    height: 30px;
    border-radius: 50% 50% 0 0/100% 100% 0 0;
    border: 1px solid #3d70b7;
    position: absolute;
    border-bottom: 0;
    bottom: 180px;
    left: -19px;
    z-index: 4;
    transform: rotate(90deg);
    background: #f0f0f0;
  }
  &:before {
    content: "";
    width: 62px;
    height: 30px;
    border-radius: 50% 50% 0 0/100% 100% 0 0;
    border: 1px solid #3d70b7;
    position: absolute;
    border-bottom: 0;

    right: -19px;
    z-index: 56;
    -webkit-transform: rotate(-90deg);
    transform: rotate(-90deg);
    background: #f0f0f0;
    bottom: 180px;
  }
  .title {
    font-size: 40px;
    color: #005192;
    font-weight: 600px;
    padding: 0 77px;
  }
  p {
    margin-top: 10px;
    text-align: left;
    color: #587fab;
    font-size: 30px;
    padding-right: 90px;
    padding: 0 77px;
    &.last {
      margin-bottom: 55px;
    }
  }
  .des {
    border-top: 1px dashed #005192;
    padding-top: 30px;
    p {
      color: #b3b3b3;
      font-size: 26px;
      font-weight: 500;
      line-height: 52px;
      text-align: left;
      padding: 0 77px;
    }
  }
}
.footer {
  position: absolute;
  bottom: 0;
  left: 0;
  padding: 60px;
  font-size: 24px;
  width: 100%;
  p {
    color: #5a5a5a;
    font-size: 20px;
    overflow: hidden;
    vertical-align: middle;
    .tel {
      float: right;
      color: #1c78f7;
      font-size: 20px;
      display: inline-block;
      vertical-align: middle;
      span {
        margin-left: 10px;
        font-size: 34px;
        font-weight: 800;
        vertical-align: middle;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Detail.vue